<template>
  <header>
    <div class="inner">
      <h1 class="logo alp"><a class="alp" href="/"><img src="/img/logo_menu.png" alt="まなびアサヒ.com"></a></h1>
      <Gnav></Gnav>
      <footnav></footnav>
      <ul class="sns">
        <li><a class="alp" target="_blank" :href="getTwLink()"><img src="../assets/img/common/tw.png" /></a></li>
        <li><a class="alp" target="_blank" :href="getFbLink()"><img src="../assets/img/common/fb.png" /></a></li>
      </ul>
    </div>
    <a class="btn-ham" @click="onClickHamburger"></a>
  </header>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
header {
  width: 100%;
  position: relative;
  background: #fff;
  border-bottom: 1px solid #eee;
  .inner {
    @include flex();
    align-items: center;
    max-width: 1000px;
    padding: 0 10px;
    margin: 0 auto;
    height: 80px;
    .logo {
      display: block;
      max-width: 195px;
      width: 19.9%;
      img {
        width: 100%;
      }
    }
    .sns {
      @include flex();
      a {
        display: block;
        width: 33px;
        img {
          width: 100%;
        }
      }
      a:last-child {
        margin-left: 13px;
      }
    }
  }
  .btn-ham {
    display: none;
  }

  @media only screen and (max-width: 750px) {
    border-bottom: none;
    .inner {
      display: block;
      height: auto;
      padding: 0;
      .logo {
        width: 100%;
        max-width: 100%;
        padding: 4vw 5.35vw;
        height: 14.67vw;
        img {
          width: 48vw;
        }
      }
      .sns {
        padding: 8vw 0;
        width: 28vw;
        margin: 0 auto;
        a {
          width: 9.87vw;
        }

        a:last-child {
          margin: 0;
        }
      }
    }
    .btn-ham {
      display: block;
      background: url(../assets/img/common/menu_ham.png) no-repeat left center;
      width: 6.67vw;
      height: 5.6vw;
      position: absolute;
      background-size: 100% auto;
      top: 4.4vw;
      right: 5.4vw;
    }
  }
}
</style>

<script>
import Gnav from "../components/Gnav";
import footnav from "../components/footnav";
import c from "../utils/ComponentUtils";
export default {
  name: "Header",
  components: {
    Gnav,
    footnav
  },
  props: ["isOpenModal"],
  methods: Object.assign({
      site_root () {
        return window.location.href.split(window.location.hostname)[0] + window.location.hostname
      },
      onClickHamburger() {
        const newOpenModal = !this.isOpenModal;
        this.$emit("update:isOpenModal", newOpenModal);
      },
      getTwLink () {
        return this.tw(this.site_root(), "朝日学生新聞社：こどもの学び応援サイト「まなびアサヒ.com」")
      },
      getFbLink () {
        return this.fb(this.site_root())
      }
  }, c)
};
</script>
